import React, { useEffect, useState } from 'react'
import PageHeader from '../../shared/page-header/PageHeader';
import SKAlerts, { CreateAlert } from "../../shared/common-alerts/SKAlerts";
import axios from 'axios';
import { getStorageValues } from '../../shared/CommonFunctions';
import { getApiBaseUrl } from '../../utils/apiConfig';
import { getModulePermissions } from '../../utils/permissionHelper';
import { exportToExcel, exportToPDF } from '../../utils/downloadExportedFiles';
import DealerModal from './DealerModal';
import DealerGrid from './DealerGrid';

function DealerMain(props) {
  const [dealerList, setDealerList] = useState([]);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [alert, setAlert] = useState(null);
  const [getUserModulePermission, setUserModulePermission] = React.useState([]);
  
  useEffect(() => {
    const modulePermissions = getModulePermissions(props.Module);
    setUserModulePermission(modulePermissions ? modulePermissions : []);
    fetchDealers();
  }, [props.Module]);

  function openAddModal() {
    setIsOpen(true);
  }
  function closeModal() {
    setIsOpen(false);
  }
  async function onSubmit(e, data) {
    if (e.target.name === "Add") {
      const dealerModel = data;
      if(dealerModel){
        let dealerDetails = {
          DealerId: null,
          DealerName: dealerModel.DealerName ? dealerModel.DealerName : "",
          MobileNumber: dealerModel.MobileNumber ? dealerModel.MobileNumber : "",
          EmailId: dealerModel.EmailId ? dealerModel.EmailId : "",
          AddressLine1: dealerModel.AddressLine1 ? dealerModel.AddressLine1 : "",
          AddressLine2: dealerModel.AddressLine2 ? dealerModel.AddressLine2 : "",
          AddressLine3: dealerModel.AddressLine3 ? dealerModel.AddressLine3 : "",
          City: dealerModel.City ? dealerModel.City : "",
          State: dealerModel.State ? dealerModel.State : "",
          Country: dealerModel.Country ? dealerModel.Country : "",
          PinNumber: dealerModel.PinNumber ? dealerModel.PinNumber : "",
          UserId: getStorageValues('userId')
        };
        if (validation(dealerDetails)) {
          try {
            const response = await axios.post(
              getApiBaseUrl() + "/dealer/save",
              dealerDetails
            );
            if (response.status === 200) {
              const payload = response.data.data && response.data.data[0] ? response.data.data[0] : null;
              if(payload && payload.success === 1){
                const newDealerId = payload.DealerId;
                if (dealerModel.PendingFiles && dealerModel.PendingFiles.length && newDealerId) {
                  await uploadPendingFiles(newDealerId, dealerModel.PendingFiles);
                }
                CreateAlert(payload.message, "Success", setAlert);
                fetchDealers();
                closeModal();
              } else {
                CreateAlert(payload?.message || "Unable to save dealer", "Error", setAlert);
              }
            } 
          } catch (error) {
            console.log(error);
          }
        }
      } else {
        CreateAlert("Fields marked with an asterisk (*) are required!!", "Error", setAlert);
      }
    } 
  }
  function validation(dealerDetails) {
    var validation = true;
      if (dealerDetails) {
      if (dealerDetails.DealerName !== null && dealerDetails.DealerName !== undefined) {
        if (dealerDetails.DealerName.length === 0) {
          CreateAlert("Please enter dealer!!", "Warning", setAlert);
          validation = false;
          return;
        }
      } else {
        CreateAlert("Please enter dealer!!", "Warning", setAlert);
        validation = false;
        return;
      }
    } else {
      CreateAlert("Some proplem fetching dealer details entered by the user!!", "Error", setAlert);
      validation = false;
      return;
    }
    return validation;
  }
  const fetchDealers = async () => {
    try {
      const body = { UserId: getStorageValues('userId') };
      const response = await axios.post(getApiBaseUrl() + "/dealer/getall", body);
      if (response.status === 200) {
        setDealerList(response.data.data[0]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const uploadPendingFiles = async (dealerId, pendingFiles = []) => {
    const groups = pendingFiles.reduce((acc, item) => {
      const key = item.FileCategory || 'General';
      acc[key] = acc[key] || [];
      acc[key].push(item);
      return acc;
    }, {});

    for (const [category, files] of Object.entries(groups)) {
      const formData = new FormData();
      formData.append('entityId', dealerId);
      formData.append('entityType', 'dealer');
      formData.append('fileCategory', category);
      formData.append('fileTitle', files[0]?.FileTitle || '');
      formData.append('UserId', getStorageValues('userId'));
      files.forEach((file) => {
        if (file.file) {
          formData.append('files', file.file, file.OriginalName);
        }
      });
      await axios.post(getApiBaseUrl() + "/file/upload", formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
    }
  };
  const handleExportExcel = () => {
    const columns = [
      { name: "Dealer", selector: "DealerName" },
      { name: "Mobile", selector: "MobileNumber" },
      { name: "Email", selector: "EmailId" },
      { name: "City", selector: "City" },
      { name: "State", selector: "State" },
      { name: "Country", selector: "Country" },
      { name: "Pin", selector: "PinNumber" },
    ];
    exportToExcel("Dealers", columns, dealerList);
  };
  
  const handleExportPDF = () => {
    const columns = [
      { name: "Dealer", selector: "DealerName" },
      { name: "Mobile", selector: "MobileNumber" },
      { name: "Email", selector: "EmailId" },
      { name: "City", selector: "City" },
      { name: "State", selector: "State" },
      { name: "Country", selector: "Country" },
      { name: "Pin", selector: "PinNumber" },
    ];
    exportToPDF("Dealers", columns, dealerList);
  };
  return (
    <>
      <SKAlerts alert={alert} />
      <PageHeader
        displayModule={props.Module}
        onModelOpen={openAddModal} 
        onRefresh={fetchDealers}
        showPDF={true}
        showExcel={true}
        showPrint={false}
        showRefresh={true}
        onExcelExport={handleExportExcel}
        onPdfExport={handleExportPDF}
        showAddButton={getUserModulePermission.AddModule === 1 ? true : false}
      />
      <DealerGrid DealerData={dealerList} fetchDealers={fetchDealers} UserPermissions={getUserModulePermission}/>
      <DealerModal
        show={modalIsOpen}
        UserAction={"Add"}
        onClose={closeModal}
        onSubmit={onSubmit}
        moduleName ={props.Module}
      />
    </>
  )
}

export default DealerMain